<top-banner variant="title" [title]="userCourseType === 'contractor' ? 'Outage Acceptance Section' : 'Inductions and Training Course Section'"></top-banner>

<p-dialog header="Please wait..." [(visible)]="energiaOverrideIsLoading" modal="true" [closable]="false" [resizable]="false" [style]="{'min-height': '50px'}" appendTo="body" [baseZIndex]="500">
  <div>
    Currently updating the other Energia Inductions
  </div>
  <div style="width: 50px; margin: 0 auto">
    <p-progressSpinner [style]="{ width: '50px', height: '50px' }" [strokeWidth]="4"></p-progressSpinner>
  </div>
</p-dialog>

<div class="main-content">
  <div class="row animated fadeIn">
    <div class="col-md-12" *ngIf="selectedTrainingSection">

      <ng-container *ngIf="selectedTrainingSection.sectionType === TrainingSectionType.Video">
        <training-video [sectionData]="selectedTrainingSection" [userCourseType]="userCourseType" [backLink]="backLink" (onSubmitSection)="onSubmitSection()" (onGoToNextSection)="goToNextSection()"></training-video>
      </ng-container>

      <ng-container *ngIf="selectedTrainingSection.sectionType === TrainingSectionType.Pdf">
        <training-pdf [sectionData]="selectedTrainingSection" [userCourseType]="userCourseType" [backLink]="backLink" (onSubmitSection)="onSubmitSection()" (onGoToNextSection)="goToNextSection()"></training-pdf>
      </ng-container>

      <ng-container *ngIf="selectedTrainingSection.sectionType === TrainingSectionType.Question">
        <training-question [workerUserCourseId]="workerUserCourseId" [userCourseType]="userCourseType" [sectionData]="selectedTrainingSection" [backLink]="backLink" (onGoToNextSection)="goToNextSection()"></training-question>
      </ng-container>

    </div>
  </div>
</div>
